;(function () {
  var TEST_ID = '69f34144c223ab6cfd5be834'

  // Variation A: always free shipping → hide bar entirely
  // Variation B: free shipping from €50 (5000 cents) → show bar with progress
  var VARIATION_B_THRESHOLD = 5000

  function getVariation() {
    try {
      if (window.Eraya && window.Eraya.sdk) {
        var mgr = window.Eraya.sdk.getShippingTestManager()
        var active = mgr.getActiveTests()
        return active[TEST_ID] || null
      }
    } catch (e) {}

    // Fallback: read directly from localStorage (same key the SDK uses)
    try {
      var raw = localStorage.getItem('eraya_shipping_test')
      if (raw) {
        var assignments = JSON.parse(raw)
        if (Array.isArray(assignments)) {
          var match = assignments.find(function (a) {
            return a.testId === TEST_ID
          })
          return match ? match.activeVariation : null
        }
        for (var userId in assignments) {
          var userAssignments = assignments[userId]
          if (userAssignments && userAssignments[TEST_ID]) {
            return userAssignments[TEST_ID]
          }
        }
      }
    } catch (e) {}

    return null
  }

  // Dutch locale money formatter: cents → €X,XX
  function formatMoney(cents) {
    var amount = cents / 100
    return '\u20AC' + amount.toFixed(2).replace('.', ',')
  }

  // ─── Cartix bar ────────────────────────────────────────────────────────────

  function applyToCartixBar(variation, cartTotal) {
    var bar = document.querySelector('#cart-drawer-app .eraya-cartix-bar')
    if (!bar) return

    if (variation === 'a') {
      bar.style.display = 'none'
      return
    }

    if (variation === 'b') {
      var threshold = VARIATION_B_THRESHOLD
      var progress = Math.min(1, Math.max(0, cartTotal / threshold))
      var remaining = Math.max(0, threshold - cartTotal)

      var fill = bar.querySelector('.eraya-cartix-bar__fill')
      var notMet = bar.querySelector('.eraya-cartix-bar__msg--no')
      var met = bar.querySelector('.eraya-cartix-bar__msg--yes')

      // Animate fill bar
      if (fill) fill.style.width = Math.round(progress * 100) + '%'

      if (progress >= 1) {
        if (notMet) notMet.style.display = 'none'
        if (met) met.style.display = ''
      } else {
        if (met) met.style.display = 'none'
        if (notMet) {
          notMet.style.display = ''
          notMet.textContent =
            'Nog ' + formatMoney(remaining) + ' tot gratis verzending'
        }
      }

      bar.style.display = ''
    }
  }

  function updateCartixBar() {
    var variation = getVariation()
    if (!variation) return

    fetch('/cart.js')
      .then(function (r) {
        return r.json()
      })
      .then(function (cart) {
        // Use original_total_price (before discounts) so discount codes
        // don't artificially inflate the progress toward free shipping
        applyToCartixBar(
          variation,
          cart.original_total_price || cart.total_price || 0,
        )
      })
      .catch(function () {})
  }

  // ─── Observer — re-runs whenever Cartix re-renders ─────────────────────────

  var cartixObserverTimer = null

  function startCartixObserver() {
    var cartApp = document.getElementById('cart-drawer-app')
    if (!cartApp) {
      setTimeout(startCartixObserver, 500)
      return
    }

    updateCartixBar()

    new MutationObserver(function () {
      clearTimeout(cartixObserverTimer)
      cartixObserverTimer = setTimeout(updateCartixBar, 150)
    }).observe(cartApp, { childList: true, subtree: true })
  }

  // ─── Init ──────────────────────────────────────────────────────────────────

  function init() {
    startCartixObserver()
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }

  // Re-run after Eraya SDK finishes initialising (variation may not be known yet)
  window.addEventListener('erayaSaaSReady', function () {
    updateCartixBar()
  })

  // Safety retries for late SDK load
  setTimeout(updateCartixBar, 800)
  setTimeout(updateCartixBar, 2000)
})()
